import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Snapshot } from 'types';

export const deleteMask = ({
  snapshotId,
  maskId,
}: {
  snapshotId: number;
  maskId: number;
}) => {
  return axios.delete(`/api/snapshots/${snapshotId}/spectral-masks/${maskId}`);
};

type UseDeleteMaskOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof deleteMask>;
};

export const useDeleteMask = ({ config, snapshotId }: UseDeleteMaskOptions) => {
  return useMutation({
    onMutate: async (deletedMask) => {
      await queryClient.cancelQueries(['snapshot', snapshotId]);

      const previousSnapshot = queryClient.getQueryData<Snapshot>([
        'snapshot',
        snapshotId,
      ]);

      queryClient.setQueryData(['snapshot', snapshotId], {
        ...previousSnapshot,
        masks: previousSnapshot?.masks?.filter(
          (mask) => mask.id !== deletedMask.maskId
        ),
      });

      return previousSnapshot;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: deleteMask,
  });
};
